export default __webpack_public_path__ + "static/media/frg--community-cafe.e0b9536a.png";